module.exports = __webpack_public_path__ + "img/mayores.91297fc6.png";